import { IBooking, ICustomer } from "shared-types/index";
import ObjectCopyService from "external-services/object-copy-service/index";
import {AxiosInstance} from "axios";
import AdminService from "external-services/diary-admin-service/admin.service";

import CustomerUpdateService from "external-services/customer-update-service/customerUpdate.service";
import NetworkRequestsService from 'external-services/network-requests-service/index';
import DateUtilsService from 'external-services/date-utils-service';
import CustomerLookupService from 'external-services/customer-lookup-service';


const NS = 'CustomerNotificationService'; // jshint ignore:line

const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();
export const getApiInstanceForTests = (): AxiosInstance => api;

class CustomerNotificationService {

  /**
     * Send Email
     * @param {email} Email
     */
  public sendLinkPayment(booking: IBooking, newEmail: string, saveToCustomer: boolean, url: string, bookedByNotification: boolean): Promise<boolean> {
    if (!booking) {
      return Promise.resolve(false);
    }

    // Online request chuncked to not exceed browsers URI length limit
    // var requests = [];
    // var idsChunkSize = 40;
    //
    const info = ObjectCopyService.angularSafeCopy(booking);

    return CustomerLookupService.getById(info.customerId).then((customer: ICustomer) => {
      // Integrate customer and notification into the notification data
      //delete info.customerId;
      info.customer = customer;
      info.time = DateUtilsService.dateToDateTimeStr(info.time);
      return api.post(AdminService.getVenueEndpointURL() + '/sendLinkPayment', info, {
        params: {
          email: newEmail,
          url: url,
          bookedByNotification: bookedByNotification
        }
      }).then(() => {
        if (saveToCustomer) {
          customer.email = newEmail;
          CustomerUpdateService.update(customer);
        }
        return true;
      }).catch(() => {
        return false;
      });
    });
  }

  /**
   * Send sms payment link
   * @param {mobilePhone} mobilePhone
   */
  public sendSmsLinkPayment(booking: IBooking, mobilePhone: string, saveToCustomer: boolean, url: string, bookedByNotification: boolean): Promise<boolean> {
    if (!booking) {
        return Promise.resolve(false);
    }
    const info = ObjectCopyService.angularSafeCopy(booking);

    return CustomerLookupService.getById(info.customerId).then((customer: ICustomer) => {
      // Integrate customer and notification into the notification data
      //delete info.customerId;
      info.customer = customer;
      info.time = DateUtilsService.dateToDateTimeStr(info.time);
      return api.post(AdminService.getVenueEndpointURL() + '/sendSmsLinkPayment', info, {
        params: {
          mobilePhone: mobilePhone,
          url: url,
          bookedByNotification: bookedByNotification
        },
      }).then(() => {
        if (saveToCustomer) {
          customer.phone = mobilePhone;
          CustomerUpdateService.update(customer);
        }
        return true;
      }).catch(() => {
        return false;
      });
    });
  }
}

const instance = new CustomerNotificationService();
export default instance as CustomerNotificationService;
